import React, { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { getMDirectorSupportPhone, getMDirectorSupportPhoneRaw } from '@/utils/helpers';

export type FooterProps = {
  onRequestInfo: () => void;
};

export const Footer = ({ onRequestInfo }: FooterProps) => {
  const { t } = useTranslation();
  const onDefaultRequestInfo = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onRequestInfo && onRequestInfo();
  };

  return (
    <div className="flex justify-between mt-8">
      <p>
        {t('Forms.help')}
        <a
          title={t('PublicFooter.phoneUs')}
          href={`tel:${getMDirectorSupportPhoneRaw()}`}
          className="ml-2 text-md-links no-underline hover:underline hover:text-md-links"
        >
          {getMDirectorSupportPhone()}
        </a>
      </p>
      <a
        href="#"
        className="text-md-links no-underline hover:underline hover:text-md-links"
        title={t('Forms.emailUsTitle')}
        onClick={onDefaultRequestInfo}
      >
        {t('Forms.emailUs')}
      </a>
    </div>
  );
};
